import React, { useState } from "react";
import dayjs from "dayjs";
import { Typography, Space, Row, Col, Card, Button } from "antd";
import Widget from "./widget/Widget";
import { WIDGET_TYPE } from "../../shared/utils/enum";
import CustomAreaChart from "./chart/CustomAreaChart";
import CustomDateTimePicker from "../../shared/components/date/CustomDateTimePicker";

const { Text } = Typography;

const Summary = () => {
    const [chartData, setChartData] = useState({ title: 'DAU', type: 'dau' });
    const [dateRange, setDateRange] = useState({
        begin: dayjs().subtract(30, 'day').unix(),
        end: dayjs().subtract(1, 'day').unix()
    });
    const [ccuData, setCcuData] = useState({ title:'CCU', type: 'ccu' });
    const [ccuDateRange, setCcuDateRange] = useState({
        begin: dayjs().subtract(1, 'hour').startOf('hour').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('hour').format('YYYY-MM-DD HH:mm:ss'),
    });

    const handleChartChange = (title, type) => {
        setChartData({ title, type });
    };

    const handleSetDateRange = (name, value) => {
        setDateRange({ ...dateRange, [name]: value });
    };

    // ccu 기간 선택 버튼 목록
    const ccuRanges = [
        { label: '1시간', value: 1, unit: 'hour' },
        { label: '3시간', value: 3, unit: 'hour' },
        { label: '12시간', value: 12, unit: 'hour' },
        { label: '1일', value: 1, unit: 'day' },
        { label: '3일', value: 3, unit: 'day' },
        { label: '1주', value: 7, unit: 'day' },
    ];

    // ccu 기간 버튼 클릭 핸들러
    const handleCcuRangeChange = (range) => {
        const now = dayjs();
        let begin, end;
        if (range.unit === 'hour') {
            begin = now.subtract(range.value, 'hour').startOf('hour').format('YYYY-MM-DD HH:mm:ss');
            end = now.endOf('hour').format('YYYY-MM-DD HH:mm:ss');
        } else if (range.unit === 'day') {
            begin = now.subtract(range.value, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
            end = now.endOf('day').format('YYYY-MM-DD HH:mm:ss');
        }
        setCcuDateRange({ begin, end });
    };

    // 현재 선택된 ccu 기간 버튼 판별
    const getActiveCcuRange = () => {
        const now = dayjs();
        for (const range of ccuRanges) {
            let begin, end;
            if (range.unit === 'hour') {
                begin = now.subtract(range.value, 'hour').startOf('hour').format('YYYY-MM-DD HH:mm:ss');
                end = now.endOf('hour').format('YYYY-MM-DD HH:mm:ss');
            } else if (range.unit === 'day') {
                begin = now.subtract(range.value, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                end = now.endOf('day').format('YYYY-MM-DD HH:mm:ss');
            }
            if (ccuDateRange.begin === begin && ccuDateRange.end === end) {
                return range.label;
            }
        }
        return null;
    };
    const activeCcuRange = getActiveCcuRange();

    return (
        <div>
            <Card
                style={{
                    marginBottom: 5,
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    border: "none",
                }}
            >
                <Space>
                    <Text>데이터 갱신 시간: {dayjs().startOf('hour').format('YYYY-MM-DD HH:mm')}</Text>
                    <Text mark>(1시간마다 갱신됩니다.)</Text>
                </Space>
            </Card>

            <Row gutter={[20, 20]} style={{ marginBottom: 2 }}>
                {Object.values(WIDGET_TYPE).map((type) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={type}>
                        <Widget
                            type={type}
                            currentType={chartData.type}
                            handleChartChange={type === WIDGET_TYPE.TOTAL ? () => { } : handleChartChange}
                        />
                    </Col>
                ))}
            </Row>


            <Card
                style={{
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    border: "none",
                    padding: 10,
                }}
            >
                <CustomDateTimePicker
                    rows={dateRange}
                    handleSetRows={handleSetDateRange}
                    hasTime={false}
                    disabled={false}
                    hasAdd={false}
                />
                <Space direction="vertical" size={32} style={{ width: '100%' }}>
                    <CustomAreaChart
                        title={chartData.title}
                        aspect={5}
                        type={chartData.type}
                        dateRange={dateRange}
                    />
                    {/* ccu 기간 선택 버튼 */}
                    <div style={{ marginBottom: 8, textAlign: 'right' }}>
                        <Space.Compact>
                            {ccuRanges.map(range => (
                                <Button
                                    key={range.label}
                                    type={activeCcuRange === range.label ? 'primary' : 'default'}
                                    onClick={() => handleCcuRangeChange(range)}
                                >
                                    {range.label}
                                </Button>
                            ))}
                        </Space.Compact>
                    </div>
                    <CustomAreaChart
                        title={ccuData.title}
                        aspect={5}
                        type={ccuData.type}
                        dateRange={ccuDateRange}
                    />
                </Space>
            </Card>
        </div>
    );
};

export default Summary;